export default "__VITE_ASSET__DbhQMr34__"